module.exports = __webpack_public_path__ + "img/children.41fe27a4.png";